import { render, staticRenderFns } from "./features_content.vue?vue&type=template&id=6c6cebd8&scoped=true&"
import script from "./features_content.vue?vue&type=script&lang=ts&"
export * from "./features_content.vue?vue&type=script&lang=ts&"
import style0 from "./features_content.vue?vue&type=style&index=0&id=6c6cebd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6cebd8",
  null
  
)

export default component.exports